import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import * as Logger from "js-logger";
import * as Store from "../../store";

import Basket from "../../components/basket";
import template from "./download.vue";
import Product from "../../models/Product";

@Component({
  mixins: [template],
  components: {
    Basket: Basket
  },
  props: {
    uuid: String,
    admin: String
  }
})
export default class DownloadView extends Vue {
  created() {
    // Store.getOrderDetails(this.$store, this.$props.uuid);
  }

  get items(): any {
    return Store.readOrder(this.$store);
  }

  get isAdmin(): boolean {
    return this.$props.admin == "admin";
  }

  alreadyDownloaded() {
    alert("Already Downloaded");
    return false;
  }

  @Watch("$route", { immediate: true, deep: true })
  onChildChanged(val: any, oldVal: any) {
    Store.getOrderDetails(this.$store, val.params.uuid);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/layouts/download/index.ts